/**
 * @generated SignedSource<<81e65600c99601b38ccce5c1208d2d5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetHomeV2Query$data = {
  readonly seriesWidgetV2Articles: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly series?: ReadonlyArray<{
            readonly entityId?: string;
            readonly publishedDate?: number | null | undefined;
          } | null | undefined> | null | undefined;
          readonly seriesShortLabel?: string | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetTabContentHomeV2Article">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "seriesWidgetHomeV2Query";
};
export type seriesWidgetHomeV2Query$key = {
  readonly " $data"?: seriesWidgetHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetHomeV2Query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seriesWidgetArticlesQueueName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetHomeV2Query",
  "selections": [
    {
      "alias": "seriesWidgetV2Articles",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "seriesWidgetArticlesQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "seriesShortLabel",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "series",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "publishedDate",
                                  "storageKey": null
                                }
                              ],
                              "type": "Content",
                              "abstractKey": "__isContent"
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "seriesWidgetTabContentHomeV2Article"
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "96c9a504e64247ad85585738ecf2a923";

export default node;
